import { Outlet } from "react-router-dom";
import React, { useEffect } from 'react';
import HeaderLogin from "./HeaderLogin";
// import '../assets/styles/auth.css';
// import { Helmet } from 'react-helmet';

function LayoutLogin() {
    useEffect(() => {          
        document.body.style.overflow = 'hidden';
        return () => {
          document.body.style.overflow = ''; // Reset on unmoun
        };
      }, []);
    
    return(
        <>        
            <HeaderLogin />
            <Outlet />
        </>
    )    
}

export default LayoutLogin;